module.exports = __webpack_public_path__ + "img/account.047835e5.svg";